import { toWSMoney } from "@wingspanhq/fe-component-library";

export const formatStatementsMoney = (amount: number): string => {
  return toWSMoney(amount).formattedValue.replace(/[^0-9., ]/g, "");
};
